export default {"src":"/_next/static/media/linkedin.2060a251.svg","height":24,"width":24};